export var PaymentSecurityScreens;
(function (PaymentSecurityScreens) {
    PaymentSecurityScreens["CANCELLED"] = "cancelled";
    PaymentSecurityScreens["DEFAULT"] = "default";
    PaymentSecurityScreens["DENIED_ENROLLMENT"] = "denied_enrollment";
    PaymentSecurityScreens["ENROLLED"] = "enrolled";
    PaymentSecurityScreens["ENROLLMENT_SUCCESS"] = "enrollment_success";
    PaymentSecurityScreens["GENERIC_ERROR"] = "generic_error";
    PaymentSecurityScreens["PENDING"] = "pending";
    PaymentSecurityScreens["TECHNICAL_ERROR_SCREEN"] = "technical_error_screen";
    PaymentSecurityScreens["UNENROLLED"] = "unenrolled";
})(PaymentSecurityScreens || (PaymentSecurityScreens = {}));
